import React, { useEffect, useState } from "react";
import {Link}                       from "react-router-dom";
import {FontAwesomeIcon}            from "@fortawesome/react-fontawesome";

import "./templates.scss";

import {OmniSearchCarousel}         from "../../omni-search-carousel/omni-search-carousel";
import {Template, WIDTH_TEMPLATE}   from "../../common/template/template";
import {ROUTE_OMNISEARCH}           from "@Xpresso/routes/omni-search/omni-search-route";

const EDGE_ITEM_DIVISOR = 3

export const Templates = ({addSearchHistoryRecord, queryParam, categories, agentHasYearlySubscription, paywallModal, agentBenefits, templateDownloadModal, userLevels}) => {
    const categoriesMassaged = massagedCategories(categories)

    return (
        <div className="templates-tmplts866">
            {
                categoriesMassaged &&
                categoriesMassaged.map((templates, i) => {
                    const textResults = templates.length === 1
                                      ? '1 RESULT'
                                      : `${templates.length} RESULTS`

                    return (
                        <div
                            className="template-container"
                            key={i}
                            xd-qa-type="card"
                            xd-qa-name={templates[0].category_name}
                        >
                            <div className="category">
                                <p className="category-text">
                                    {templates[0].category_name}
                                </p>
                                <Link
                                    className="icon-link"
                                    to={ROUTE_OMNISEARCH.BROWSE}
                                >
                                    <FontAwesomeIcon
                                            icon={require('@fortawesome/free-solid-svg-icons')['faChevronRight']}
                                            className='icon-chevron'
                                    />

                                </Link>
                            </div>
                            <div className="results">
                                <p className="results-text">
                                    {textResults}
                                </p>
                                <Link
                                    onClick={() => scrollToTop()}
                                    className="see-all"
                                    to={`${ROUTE_OMNISEARCH.BROWSE}?q=${queryParam}&categories=${templates[0].category_name}`}
                                >
                                    See All
                                </Link>
                            </div>
                            <OmniSearchCarousel
                                Component={Template}
                                items={templates}
                                widthComponent={WIDTH_TEMPLATE}
                                edgeItemVisibilityDivisor={EDGE_ITEM_DIVISOR}
                                additionalProps={{addSearchHistoryRecord, agentHasYearlySubscription, paywallModal, agentBenefits, templateDownloadModal, userLevels}}
                            />
                        </div>

                    )
                })
            }
        </div>
    )
}

const massagedCategories = (categories) => {
    if(!Array.isArray(categories)) {
        return null
    }
    if(categories.length < 1) {
        return null
    }

    const massaged = []

    for(let i = 0; i < categories.length; i++) {
        if(!Array.isArray(categories[i])) {
            continue
        }
        if(categories[i].length < 1) {
            continue
        }

        const templates = Array.from(
            new Map(categories[i].map(template => [template.id_template, template])).values()
        );

        if(templates.length > 0) {
            massaged.push(templates)
        }
    }

    return massaged.sort().reverse()
}

const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
}